import { To } from "react-router-dom";
import { styled } from "styled-components";
import { Link } from "components/link";

const PatientCardListItemContainer = styled.div`
  display: grid;
  grid-template-columns: min-content auto;
  grid-template-rows: auto auto;
  column-gap: 8px;
  row-gap: 2px;
  align-items: center;
`;

const IconContaner = styled.div`
  flex-shrink: 0;
  display: flex;
`;

type PatientCardListItemProps = {
  onClose: () => void;
  to: To;
  dataTestId: string;
  linkText: string;
  icon: React.ReactElement;
  footer?: React.ReactElement;
};

const PatientCardListItem = ({
  onClose,
  to,
  dataTestId,
  linkText,
  icon,
  footer,
}: PatientCardListItemProps) => {
  return (
    <PatientCardListItemContainer>
      <IconContaner>{icon}</IconContaner>
      <Link onClick={onClose} to={to} data-testid={dataTestId} variant="body">
        {linkText}
      </Link>
      <div />
      {footer}
    </PatientCardListItemContainer>
  );
};

export default PatientCardListItem;
